
const todoStates = Object.freeze({
  PENDING: 'PENDING',
  OPEN: 'OPEN',
  STARTED: 'STARTED',
  FINISHED: 'FINISHED'
})

export default todoStates
